<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  ">
    <span style="color: white; float: right; margin: 4% 7%; position: relative;" *ngIf="(version)"> <h6>V{{version}}</h6> </span>
    <p-dialog [(visible)]="displaypopupMFACreate"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '30vw' }">
        <p-header>
            <h2 class="mb-0"
                style="
          font-weight: bold !important;
          font-size: large !important;
          justify-content: center;
        ">
                {{ title }}
            </h2>
        </p-header>

        <div class="grid" style="text-align: center !important">
            <!--Scan QR-->
            <div *ngIf="selectedViewIndex == 1" style="text-align: left">
                <!--<p-message severity="success" text="Setup Multi-factor Authentication (MFA)" style="background-color: #fccdb3 !important; text-align: center; " styleClass="p-mr-2"></p-message>-->
                <br />
                <div class="row pr-5 pl-5" style="color: gray">
                    <div class="col-sm-4">
                        <strong style="color: red">Step 1: </strong> <br />

                        <ul style="text-align: left">
                            <li>
                                To setup multi-factor authentication (MFA) for your account,
                                Scan the QR code with an authenticator app.
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-4 pt-4"
                         style="align-content: center; text-align: center">
                        <img [src]="qr" height="150" width="150" />
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="row">
                    <div class="col" style="position: relative; text-align: center">
                        <hr style="border: none; border-top: 1px solid #ccc; margin: 20px 0" />
                        <span style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #fff;
                padding: 0 10px;
              ">
                            OR
                        </span>
                    </div>
                </div>
                <div class="row pl-5">
                    <div class="col" style="display: flex; align-items: center">
                        <span>
                            For manual setup you can use the following key. Use the
                            HMAC-SHA-1 algorithm for configuration.
                        </span>
                    </div>
                </div>
                <div class="row pl-5">
                    <div class="col" style="display: flex; align-items: center">
                        <b>{{ authkey }}</b>
                    </div>
                </div>

                <br />
                <div class="row pr-5 pl-5 pb-2"
                     style="align-content: center; text-align: center; color: gray">
                    <div class="col-sm-4" style="text-align: left">
                        <strong style="color: red"> Step 2: </strong><br />
                        <ul style="text-align: left">
                            <li>
                                Once scanned, Please enter the 6-digit code displayed on your
                                authenticator app from your device.
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-4 mt-3"
                         style="display: inline-block !important;align-content: center;text-align: center;">
                        <div style="color: black">
                            <label for="txtFinalCode"><b>Authentication Code:</b></label>
                        </div>
                        <div class="mt-3">
                            <input type="text"
                                   id="txtFinalCode"
                                   class="form-control"
                                   placeholder="[Authentication Code]"
                                   [(ngModel)]="authCode"
                                   (keyup.enter)="btnValidateAppAuthCode_Click()"
                                   style="text-align: center;width: 250px;display: inline-block !important;" autocomplete="off" />
                        </div>
                    </div>
                    <div class="col-sm-4"></div>
                </div>
                <br />
                <p-message *ngIf="showError"
                           [ngStyle]="{ 'padding-bottom': '2px' }"
                           severity="error"
                           text="{{ errorMessage }}"
                           styleClass="p-2"></p-message>



                <div class="row" style="text-align: center !important">
                    <div class="col">
                        <button type="button"
                                icon="pi"
                                pButton
                                style="width: 200px; padding-left: 77px"
                                class="p-mb-6 p-px-3"
                                (click)="btnValidateAppAuthCode_Click()">
                            Validate
                        </button>
                    </div>
                </div>
            </div>


        </div>
    </p-dialog>
    <p-dialog [(visible)]="displaypopupMFALogin"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '30vw' }">
        <p-header>
            <h2 class="mb-0"
                style="
      font-weight: bold !important;
      font-size: large !important;
      justify-content: center;
    ">
                {{ title }}
            </h2>
        </p-header>

        <div class="grid" style="text-align: center !important">
            <!--Scan QR-->
            <!--Enter Auth code-->
            <div *ngIf="selectedViewIndex == 2">
                <br />
                <div class="mfaImage pb-3">
                    <img src="../../../../assets/imagesNew/mfaLock.png" />
                </div>
                <p-message severity="none"
                           text=" Please enter the 6-digit code displayed on your authenticator app from your device."
                           styleClass="pr-5 pl-5 pb-2"
                           [ngStyle]="{ 'font-weight': '200' }">
                </p-message>

                <div>&nbsp;</div>
                <div class="row">
                    <div class="col">
                        <label for="txtFinalCode"
                               style="font-family: Verdana; font-size: large; font-weight: bold">Authentication Code:</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="text"
                               id="txtFinalCode"
                               class="form-control"
                               placeholder="[Enter Authentication Code]"
                               [(ngModel)]="authCode"
                               (keyup.enter)="btnValidateAppAuthCode_Click()"
                               style="text-align: center;width: 300px;display: inline-block !important;height: 30px;" autocomplete="off" />
                    </div>
                </div>
                <br />
                <p-message *ngIf="showError"
                           [ngStyle]="{ 'padding-bottom': '2px' }"
                           severity="error"
                           text="{{ errorMessage }}"
                           styleClass="p-2"></p-message>
                <br />
                <div class="row">
                    <div class="col">
                        <button type="button"
                                style="justify-content: center"
                                icon="pi"
                                pButton
                                class="p-mb-3 p-px-3 p-button-plain buttonWidth-8"
                                (click)="btnValidateAppAuthCode_Click()">Validate
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
